import React, { FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { usePropertyListDetailQuery } from '../../graphql/generated'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { PropertyListAreaDetailTable } from '../components/PropertyListAreaDetailTable/PropertyListAreaDetailTable'
import { PropertyListBuildingDetailTable } from '../components/PropertyListBuildingDetailTable/PropertyListBuildingDetailTable'

export const PropertyList: FunctionComponent = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>()

  const [{ data }] = usePropertyListDetailQuery({
    variables: { id },
  })

  return (
    <>
      <PageLayout
        title={
          data?.propertyListById?.name
            ? 'Detail seznamu: ' + data.propertyListById.name
            : 'Detail seznamu nemovitostí'
        }
      >
        {data?.propertyListById?.propertyType === PROPERTY_TYPES.AREA ? (
          <PropertyListAreaDetailTable
            whereClause={data?.propertyListById?.whereClause || ''}
          />
        ) : (
          <PropertyListBuildingDetailTable
            whereClause={data?.propertyListById?.whereClause || ''}
          />
        )}
      </PageLayout>
      <PropertyDetailDrawer />
    </>
  )
}

export default PropertyList
